var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { small: _vm.small == "Yes" } },
    _vm._l(_vm.data, function(item) {
      return _c("div", { key: item.userID, staticClass: "card" }, [
        _c("div", { staticClass: "card-content" }, [
          _c("div", { staticClass: "media" }, [
            _c("div", { staticClass: "media-left" }, [
              _c("figure", { staticClass: "image is-48x48" }, [
                item.avatar === ""
                  ? _c("img", {
                      attrs: {
                        src: "https://services.musubi-thai.com/default.png",
                        alt: "Placeholder image"
                      }
                    })
                  : _c("img", {
                      attrs: {
                        src:
                          "https://api.musubi-thai.com/public/profile/" +
                          item.avatar,
                        alt: "Placeholder image"
                      }
                    })
              ])
            ]),
            _c("div", { staticClass: "media-content" }, [
              _c("p", { staticClass: "title is-4" }, [
                _vm._v(_vm._s(item.firstName) + " " + _vm._s(item.lastName))
              ]),
              _c("p", { staticClass: "subtitle is-6" }, [
                _c("span", { staticClass: "has-text-primary" }, [
                  _vm._v("#" + _vm._s(item.role))
                ]),
                item.isOwner
                  ? _c("span", { staticClass: "has-text-info" }, [
                      _vm._v(" Project Owner")
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9663f30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9663f30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/related-user.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d9663f30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/related-user.vue
// module chunks = 0 1 2